import { a as appGlobalScript } from './setup-3a3f57db.js';

const globalScripts = appGlobalScript;

export { globalScripts as g };

//# sourceMappingURL=app-globals-c85c7809.js.map